import { render, staticRenderFns } from "./PermissionsTreePanel.vue?vue&type=template&id=7cdde916&scoped=true&"
import script from "./PermissionsTreePanel.vue?vue&type=script&lang=js&"
export * from "./PermissionsTreePanel.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsTreePanel.vue?vue&type=style&index=0&id=7cdde916&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdde916",
  null
  
)

export default component.exports